import { isNotNullOrUndefined } from '@mri-platform/shared/core';
import { AuthService } from '@mri/angular-wfe-proxy-oidc';
import { combineLatest, map, Observable, startWith } from 'rxjs';
import { MainNavService } from './main-nav.service';

export function getCurrentClientId$(authService: AuthService, navService: MainNavService): Observable<string> {
  const authServiceSigninClientId$ = authService.userLoaded$.pipe(
    map(user => user.clientId),
    startWith(null)
  );

  // favour the client ID set in the main nav service, using the client ID from the auth service as fallback
  return combineLatest([authServiceSigninClientId$, navService.getClientId()]).pipe(
    map(([clientId, clientIdFromNavService]) => clientIdFromNavService || clientId),
    isNotNullOrUndefined()
  );
}
